import * as React from 'react';
import Select from '@mos-front-components/public/es/components/MosSelect';
import { t } from '@lingui/macro';
import cn from 'classnames';
import { Field } from '../../../declarations/widget-ums';
import { CITIZENSHIP } from '../../../constants/citizenship';
import { i18n } from '../../../helpers/i18n';
import './Citizenship.pcss';

const CITIZENSHIP_OPTIONS = [
  { text: i18n._(t`Гражданин РФ`), value: CITIZENSHIP.CITIZEN },
  {
    text: i18n._(t`Иностранный гражданин`),
    value: CITIZENSHIP.FOREIGN_CITIZEN,
  },
  { text: i18n._(t`Лицо без гражданства`), value: CITIZENSHIP.NON_CITIZEN },
];

interface Props extends Field<CITIZENSHIP | null> {
  newKey?: string;
  onChange(value: CITIZENSHIP): void;
}

function Citizenship(props: Props) {
  const value = (
    CITIZENSHIP_OPTIONS.find(({ value }) => {
      return value === props.value;
    }) || { text: '' }
  ).text;

  const classNames = cn('Citizenship', { StepContentBlock: !value });
  return (
    <div className={classNames} key={props.newKey}>
      <div className="PguFormGrid__row">
        <div className="PguFormGrid_col PguFormGrid__col_5">
          <Select
            key={props.newKey}
            dropListView
            className="PguFormGrid__field"
            suggestions={CITIZENSHIP_OPTIONS}
            value={value}
            hasError={props.error}
            placeholder={i18n._(t`Гражданство`)}
            name="citizenship"
            disabled={props.disabled}
            onChange={props.onChange}
          />
        </div>
      </div>
    </div>
  );
}

export default Citizenship;
